import { FC } from 'react'

import { clsx } from 'clsx'

import { YesIcon } from '@dfds-frontend/navigator-icons/icons'

import { ProductListSections } from '../../../api/travel-search-config'
import OverlayFooter from '../shared/OverlayFooter'

interface OffersProps {
  onClose: () => void
  onProductClicked: (minibookId: string, offerTitle: string) => void
  products: ProductListSections[]
  selectedMultiOffer: { minibookId: string; offerTitle: string } | undefined
}

export const Offers: FC<OffersProps> = ({ onClose, onProductClicked, products, selectedMultiOffer }) => {
  return (
    <div>
      {products.map((product) => (
        <ul
          className="m-0 list-none border-0 p-0 pl-0"
          data-e2e="vehicle-categories"
          data-travel-search-child
          key={product.productSectiontitle}
        >
          {product ? <div className="typography-body-md-medium p-semantic-global-xs">{product.productSectiontitle}</div> : null}
          {product.minibookProductListItems.map((items) => (
            <li
              className={clsx(
                'm-0 flex min-h-[90px] list-none items-center gap-semantic-global-md border-0 border-b border-solid border-b-semantic-global-border-light px-semantic-global-md pr-semantic-global-md',
                selectedMultiOffer?.minibookId === items.minibookContentReference
                  ? 'cursor-default bg-semantic-form-controls-background-ghost-pressed'
                  : 'cursor-pointer lg:hover:bg-semantic-global-primary-lightest'
              )}
              data-e2e={`offer-category-${items.offertitle}`}
              key={items.offertitle}
              onClick={() => {
                onProductClicked(items.minibookContentReference, items.offertitle)
              }}
            >
              <div className="flex flex-col gap-primitive-8">
                <label className="typography-body-md-medium cursor-pointer text-base text-semantic-global-text-default">
                  {items.offertitle}
                </label>
                <span className="text-semantic-global-text-light typography-body-sm-regular">{items.productDetails}</span>
              </div>
              <div className="ml-auto text-semantic-global-text-default">
                {selectedMultiOffer?.minibookId === items.minibookContentReference ? <YesIcon size="md" /> : null}
              </div>
            </li>
          ))}
        </ul>
      ))}
      <div className="border-0 border-b border-solid border-semantic-global-border-light lg:hidden" />
      <OverlayFooter onClick={onClose} />
    </div>
  )
}
